/* eslint-disable react/require-default-props */
import React, { useRef, useState } from 'react'
import SectionHeader from 'components/SectionHeader'
import { Spacing40 } from 'styles/sharedStyle'
import PropTypes from 'prop-types'
import ServiceItem from './ServiceItem/ServiceItem'
import { NavigationContainer, Section, Tab } from './ServicesCar.style'

const ServicesCar = ({
  items,
  eyebrow,
  heading,
  bodyCopy,
  villageSlug = '',
  nodeLocale = '',
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const navContainerRef = useRef(null)

  const handleClickMobile = () => {
    const targetItemIndex =
      activeIndex === items.length - 1 ? 0 : activeIndex + 1
    setActiveIndex(() => targetItemIndex)
  }

  return (
    <Section>
      <SectionHeader eyebrow={eyebrow} title={heading} content={bodyCopy} />

      <NavigationContainer ref={navContainerRef}>
        {items?.map((item, index) => (
          <Tab
            key={`tab-${index + 1}  `}
            data-testid={`service-tab-${index}`}
            isActive={index === activeIndex}
            onClick={() => setActiveIndex(index)}>
            {item.heading}
          </Tab>
        ))}
      </NavigationContainer>

      <ServiceItem
        image={items[activeIndex].image}
        heading={items[activeIndex].heading}
        benefit={items[activeIndex].benefit}
        bodyCopy={items[activeIndex].bodyCopy || { bodyCopy: '' }}
        url={items[activeIndex].url ?? ''}
        handleClick={handleClickMobile}
        ctaLabel={items[activeIndex].ctaLabel ?? ''}
        villageSlug={villageSlug}
        nodeLocale={nodeLocale}
      />
      <Spacing40 />
    </Section>
  )
}

ServicesCar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        portrait: PropTypes.shape({
          gatsbyImageData: PropTypes.shape({
            aspectRatio: PropTypes.number.isRequired,
            src: PropTypes.string.isRequired,
            srcSet: PropTypes.string.isRequired,
            srcSetWebp: PropTypes.string.isRequired,
            sizes: PropTypes.string.isRequired,
          }).isRequired,
        }),
        landscape: PropTypes.shape({
          gatsbyImageData: PropTypes.shape({
            aspectRatio: PropTypes.number.isRequired,
            src: PropTypes.string.isRequired,
            srcSet: PropTypes.string.isRequired,
            srcSetWebp: PropTypes.string.isRequired,
            sizes: PropTypes.string.isRequired,
          }).isRequired,
        }),
      }).isRequired,
      heading: PropTypes.string.isRequired,
      benefit: PropTypes.string.isRequired,
      bodyCopy: PropTypes.shape({
        bodyCopy: PropTypes.string,
      }),
      url: PropTypes.string.isRequired,
      ctaLabel: PropTypes.string,
    })
  ).isRequired,
  eyebrow: PropTypes.string,
  heading: PropTypes.string.isRequired,
  bodyCopy: PropTypes.string,
  villageSlug: PropTypes.string,
  nodeLocale: PropTypes.string,
}

ServicesCar.defaultProps = {
  eyebrow: '',
  bodyCopy: '',
}

export default ServicesCar
